<template>
    <u-dialog-flat-tile v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-dialog-flat-tile>
</template>

<script>
import UDialogFlatTile from "@/components/publish/styles/dialogs/u-dialog-flat-tile.vue";

export default {
    props: {},
    components: {
        UDialogFlatTile,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>
